import { useEffect, useState } from "react";
import { RealCommerceError } from "../../../exceptions/realCommerceError.js";
// Wraps `subscription.fetchChangePlans({ coupon })`. Initial load on
// mount; re-fetch when `applyCoupon` / `removeCoupon` is called. The hook
// centralises the (loading, error, applied) state so the modal stays
// declarative.
function usePlanList(subscription) {
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState();
    useEffect(()=>{
        let isCancelled = false;
        setIsLoading(true);
        subscription.fetchChangePlans().catch((e)=>{
            if (!isCancelled && e instanceof RealCommerceError) {
                setError(e);
            }
        }).finally(()=>{
            if (!isCancelled) {
                setIsLoading(false);
            }
        });
        return ()=>{
            isCancelled = true;
        };
    }, [
        subscription
    ]);
    const applyCoupon = async (code)=>{
        setIsLoading(true);
        setError(undefined);
        try {
            await subscription.fetchChangePlans(code);
        } catch (e) {
            if (e instanceof RealCommerceError) {
                setError(e);
            }
            throw e;
        } finally{
            setIsLoading(false);
        }
    };
    const removeCoupon = async ()=>{
        setIsLoading(true);
        setError(undefined);
        try {
            await subscription.fetchChangePlans(undefined);
        } catch (e) {
            if (e instanceof RealCommerceError) {
                setError(e);
            }
            throw e;
        } finally{
            setIsLoading(false);
        }
    };
    return {
        isLoading,
        error,
        appliedCoupon: subscription.lastAppliedCoupon,
        applyCoupon,
        removeCoupon
    };
}
export { usePlanList };
